import { render } from "./EditDetailAgendaSubKomunitasView.vue?vue&type=template&id=358b0d7a"
import script from "./EditDetailAgendaSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./EditDetailAgendaSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__